import React from "react";
import Link from "next/link";
import { Button, Col, Container, Form, Input, Row } from "reactstrap";
import Image from "next/image";
import { getImageUrl } from "../services/image";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Footer = function Footer() {
  return /*#__PURE__*/_jsxs("footer", {
    className: "position-relative z-index-10 d-print-none",
    children: [/*#__PURE__*/_jsx("div", {
      className: "py-6 bg-gray-200 text-muted dark",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            lg: 3,
            md: 6,
            className: "mb-5 mb-lg-0",
            children: [/*#__PURE__*/_jsx("div", {
              className: "font-weight-bold text-uppercase text-dark mb-3",
              children: "Diensten"
            }), /*#__PURE__*/_jsxs("ul", {
              className: "list-unstyled",
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/vakantiehuis",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Vakantiehuizen verhuur"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/camper",
                  prefetch: false,
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Camper verhuur"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/verblijf-op-maat",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Verblijf op maat"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/overtocht",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Overtochten"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/verzekeringen",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Verzekeringen"
                  })
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 2,
            md: 6,
            className: "mb-5 mb-lg-0",
            children: [/*#__PURE__*/_jsx("div", {
              className: "font-weight-bold text-uppercase text-dark mb-3",
              children: "Landen"
            }), /*#__PURE__*/_jsxs("ul", {
              className: "list-unstyled",
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/vakantiehuis/engeland",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Engeland"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/vakantiehuis/schotland",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Schotland"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/vakantiehuis/wales",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Wales"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/vakantiehuis/ierland",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Ierland"
                  })
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 3,
            md: 6,
            className: "mb-5 mb-lg-0",
            children: [/*#__PURE__*/_jsx("div", {
              className: "font-weight-bold text-uppercase text-dark mb-3",
              children: "Algemeen"
            }), /*#__PURE__*/_jsxs("ul", {
              className: "list-unstyled",
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/algemene-voorwaarden",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Algemene voorwaarden"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/garantieregeling",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Garantieregeling"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/privacybeleid",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Privacybeleid"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/disclaimer",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Disclaimer"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/contact",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "text-muted dark",
                    children: "Contact"
                  })
                })
              })]
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "py-4 font-weight-light bg-gray-800 text-gray-300",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          className: "align-items-center",
          children: [/*#__PURE__*/_jsx(Col, {
            md: "4",
            children: /*#__PURE__*/_jsx("ul", {
              className: "list-inline",
              children: /*#__PURE__*/_jsx("li", {
                className: "list-inline-item",
                children: /*#__PURE__*/_jsx(Link, {
                  href: "https://www.sto-garant.nl",
                  passHref: true,
                  children: /*#__PURE__*/_jsx("a", {
                    children: /*#__PURE__*/_jsx(Image, {
                      src: getImageUrl('logos_logo-wit-kleur-garant.png'),
                      className: "bg-image",
                      alt: "STO Garant logo",
                      height: 100,
                      width: 100
                    })
                  })
                })
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            md: "4",
            className: "text-center",
            children: /*#__PURE__*/_jsxs("p", {
              className: "text-sm mb-md-0",
              children: ["\xA9 Cottage Centre 2004 - ", new Date().getFullYear()]
            })
          }), /*#__PURE__*/_jsx(Col, {
            md: "4",
            children: /*#__PURE__*/_jsxs("ul", {
              className: "list-inline mb-5 mb-md-0 mt-2 mt-md-0 text-center text-md-right",
              children: [/*#__PURE__*/_jsx("li", {
                className: "list-inline-item mr-3 text-sm",
                children: "Volg ons op:"
              }), /*#__PURE__*/_jsx("li", {
                className: "list-inline-item text-lg",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.facebook.com/CottageCentre",
                  target: "_blank",
                  rel: "noopener",
                  title: "Facebook",
                  className: "text-white",
                  children: /*#__PURE__*/_jsx("i", {
                    className: "fab fa-facebook"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                className: "list-inline-item text-lg",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://twitter.com/CottageCentre",
                  target: "_blank",
                  rel: "noopener",
                  title: "Instagram",
                  className: "text-white",
                  children: /*#__PURE__*/_jsx("i", {
                    className: "fab fa-instagram"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                className: "list-inline-item text-lg",
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://www.instagram.com/cottage_centre/",
                  target: "_blank",
                  rel: "noopener",
                  title: "Twitter",
                  className: "text-white",
                  children: /*#__PURE__*/_jsx("i", {
                    className: "fab fa-twitter"
                  })
                })
              })]
            })
          })]
        })
      })
    })]
  });
};

export default Footer;